import { FETCH_AGE_RATINGS } from "../actions/age_rating";
import { AgeRating } from "./state";
import { AnyAction } from "redux";
import { Reducer } from "react";

const initialState: AgeRating = {
    data: [],
};

const ageRatingReducer: Reducer<AgeRating, AnyAction> = (
    state = initialState,
    action: AnyAction
) => {
    const { type, payload } = action;

    switch (type) {
        case FETCH_AGE_RATINGS:
            return {
                ...state,
                data: payload.data,
            };
        default:
            return state;
    }
};

export default ageRatingReducer;
